module.exports = __webpack_public_path__ + "static/media/HajiYonusTanoli.ab6c37d2.jpeg";